import { z } from '@qred/components-library';
import { turnoverSchema } from '~/components/shared/TurnoverSelect/TurnoverSelect';
import { LoanPurposes } from '~/enums';

// Deliberately duplicated (not imported) from StartApplication.schema.ts —
// see the comment in StartApplicationNew.schema.ts for why. Field names
// (loanPurpose.*, turnover, incomeReceivedInForeignCurrencies) are kept
// identical to StartApplicationForm so the existing LoanPurposeSelect and
// ForeignCurrencyIncome components can be reused unmodified: their
// `useFormContext<StartApplicationForm>()` typing is compile-time only,
// and this form is structurally compatible at runtime.
const validateLoanPurposeReason = (data: {
  purposeOfLoan: LoanPurposes;
  reason: string;
}) => {
  if (data.purposeOfLoan === LoanPurposes.Other) {
    return data.reason.trim().length > 0;
  }
  return true;
};

const loanPurposeSchema = z
  .object({
    purposeOfLoan: z.nativeEnum(LoanPurposes, {
      required_error: 'ValidationErrors.Required',
    }),
    reason: z.string().max(190, {
      message: 'ValidationErrors.MaxLength190',
    }),
  })
  .refine(validateLoanPurposeReason, {
    message: 'ValidationErrors.Required',
    path: ['reason'],
  });

export const BusinessNeedsSchema = z.object({
  loanPurpose: loanPurposeSchema,
  ...turnoverSchema.shape,
  incomeReceivedInForeignCurrencies: z.boolean({
    required_error: 'ValidationErrors.Required',
  }),
});

export type BusinessNeedsForm = z.infer<typeof BusinessNeedsSchema>;
